var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5C13.8954 5 13 5.89543 13 7V17C13 19.2091 11.2091 21 9 21C6.79086 21 5 19.2091 5 17V6H7V17C7 18.1046 7.89543 19 9 19C10.1046 19 11 18.1046 11 17V7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7V17H17V7C17 5.89543 16.1046 5 15 5Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86351 3.48075C6.47763 2.81924 5.52183 2.81924 5.13595 3.48075L3.37699 6.49611C2.9881 7.16277 3.46897 7.99998 4.24076 7.99998H7.75869C8.53048 7.99998 9.01135 7.16277 8.62247 6.49612L6.86351 3.48075Z",
    fill: "#12131A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9997 15C16.3429 15 14.9997 16.3431 14.9997 18C14.9997 19.6569 16.3429 21 17.9997 21C19.6566 21 20.9997 19.6569 20.9997 18C20.9997 16.3431 19.6566 15 17.9997 15ZM16.9997 18C16.9997 17.4477 17.4474 17 17.9997 17C18.552 17 18.9997 17.4477 18.9997 18C18.9997 18.5523 18.552 19 17.9997 19C17.4474 19 16.9997 18.5523 16.9997 18Z",
    fill: "#12131A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.b7bbd2ae742b00001a31175af6c41f79.svg";
export { ForwardRef as ReactComponent };